import { useQuery } from '@tanstack/react-query';
import { CurrentUserType } from '../../../types';
import { QueryKeys } from '../../../constants';

export const useGetCurrentUser = () => {
	return useQuery<CurrentUserType>({
		queryKey: [QueryKeys.CURRENT_USER],
	});
};
